// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__wUkp7","contentContainer":"page_contentContainer__DMN74"};